module.exports = __webpack_public_path__ + "media/img/event/sponsor/stpaul-logo-1fc9153e8b50853bb8cb17f4490df219.png";